module.exports = __webpack_public_path__ + "img/activity9.85417beb.jpg";